import React, { useEffect, useRef, useState } from 'react';
import hljs from 'highlight.js';

function decodeHtmlEntities(value) {
	const textarea = document.createElement('textarea');
	textarea.innerHTML = value;
	return textarea.value;
}

function CodeHighlight({ className = 'xml', src }) {
	const [code, setCode] = useState('Loading example...');
	const codeRef = useRef(null);

	useEffect(() => {
		let active = true;
		fetch(src)
			.then((response) => {
				if (!response.ok) throw new Error(`Unable to load ${src}`);
				return response.text();
			})
			.then((value) => {
				if (active) setCode(decodeHtmlEntities(value));
			})
			.catch(() => {
				if (active) setCode('Example source is unavailable.');
			});

		return () => {
			active = false;
		};
	}, [src]);

	useEffect(() => {
		if (codeRef.current) {
			hljs.highlightElement(codeRef.current);
		}
	}, [code, className]);

	return <code ref={codeRef} className={className}>{code}</code>;
}

export default CodeHighlight;
